import { Message } from 'element-ui'
import { CreateAliPayToken, QueryOrderStatus, DeviceRecharge, SmsRecharge } from '@/api/Payment/actions'

class paymanager {
  constructor (options) {
    /** 支付配置 */
    this.options = {
      /** 用户主键 */
      userid: options.userid || '',
      /** 支付成功回调 */
      paySuccessCall: options.paySuccessCall || null,
      /** 订单过期回调 */
      orderExpireCall: options.orderExpireCall || null,
    }
    /** 支付宝支付token */
    this.aliPayToken = options.aliPayToken || ''
    /** 订单配置信息 */
    this.order = {
      /** 订单编号 */
      orderNumber: options.orderNumber || '',
      /** 订单有效时长[以秒为单位]，默认15分钟 */
      orderValidDuration: (options.orderValidDuration || (15 * 60)),
      /** 订单轮询间隔[以秒位单位]，默认5秒 */
      orderLoopInterval: (options.orderLoopInterval || 5) * 1000,
      /** 订单倒计时 */
      orderCountdownString: options.orderCountdownString || '',
      /** 订单支付倒计时任务 */
      orderPayCountdownTask: options.orderPayCountdownTask || null,
    }
  }

  get orderCountdownString () {
    return this.order.orderCountdownString
  }

  /** 获取支付宝支付token */
  queryAlipayToken () {
    return new Promise((resolve, reject) => {
      CreateAliPayToken(this.options.userid).then(response => {
        if (response.code === 0) {
          this.aliPayToken = response.data
          resolve()
        } else {
          reject(response.message)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  }

  /** 创建订单成功 */
  createOrderSuccess () {
    this.order.orderPayCountdownTask = window.setInterval(() => {
      this.orderPayCountdowm()
    }, 1000)
    this.loopOrderStatus()
  }

  /** 订单支付超时 */
  orderPayExpire () {
    this.clearOrderPay()
    this.options.orderExpireCall?.apply(this)
  }

  /** 订单支付成功 */
  orderPaySuccess () {
    this.clearOrderPay()
    this.options.paySuccessCall?.apply(this)
  }

  /** 格式化订单倒计时 */
  formatOrderCountdown () {
    const minute = Math.floor(this.order.orderValidDuration / 60)
    const second = Math.floor(this.order.orderValidDuration % 60)
    this.order.orderCountdownString = `${minute > 9 ? minute : `0${minute}`}分${second > 9 ? second : `0${second}`}秒`
  }

  /** 清理订单支付信息 */
  clearOrderPay () {
    this.order.orderNumber = ''
    if (this.order.orderPayCountdownTask) {
      window.clearInterval(this.order.orderPayCountdownTask)
    }
  }

  /** 轮询订单状态 */
  loopOrderStatus () {
    if (this.order.orderNumber) {
      QueryOrderStatus(this.order.orderNumber, this.aliPayToken).then(response => {
        if (response.data !== 'TRADE_SUCCESS') {
          window.setTimeout(() => {
            this.loopOrderStatus()
          }, this.order.orderLoopInterval)
        } else {
          this.orderPaySuccess()
        }
      }).catch(message => {
        Message.error(`获取订单状态失败：${message}`)
      })
    }
  }

  /** 订单支付倒计时 */
  orderPayCountdowm () {
    if (this.order.orderValidDuration > 0) {
      --this.order.orderValidDuration
      this.formatOrderCountdown()
    } else {
      this.orderPayExpire()
    }
  }

  /** 设备充值 */
  deviceRecharge (data) {
    return new Promise((resolve, reject) => {
      this.queryAlipayToken().then(() => {
        DeviceRecharge(data, this.aliPayToken).then(response => {
          this.order.orderNumber = response.data.orderNumber
          const iframeQrCode = response.data.aliPayApiResponse
          this.createOrderSuccess()
          resolve(iframeQrCode)
        }).catch((error) => {
          reject(`创建订单失败：${error}`)
        })
      }).catch((error) => {
        reject(`获取支付token失败：${error}`)
      })
    })
  }

  /** 短信充值 */
  smsRecharge (data) {
    return new Promise((resolve, reject) => {
      this.queryAlipayToken().then(() => {
        SmsRecharge(data, this.aliPayToken).then(response => {
          this.order.orderNumber = response.data.orderNumber
          const iframeQrCode = response.data.aliPayApiResponse
          this.createOrderSuccess()
          resolve(iframeQrCode)
        }).catch(error => {
          reject(`创建订单失败：${error}`)
          this.options.createOrderFailCall?.apply(this)
        })
      }).catch(error => {
        Message.error(`获取支付token失败：${error}`)
        this.options.createOrderFailCall?.apply(this)
      })
    })
  }
}

export default paymanager
